export const EMAIL_REGEX = '^.+@.+\\.[a-zA-Z]{2,63}$'
